import { User, UserCheckResult } from '../types/user';

// Mock user data
// const mockUsers: User[] = [
//   {
//     id: '1',
//     name: 'John Doe',
//     email_address: 'john.doe@example.com',
//     username: 'johndoe',
//     joinDate: '2023-01-15',
//     status: 'active',
//     location: 'San Francisco, CA',
//     bio: 'Full-stack developer passionate about creating amazing user experiences.'
//   },
//   {
//     id: '2',
//     name: 'Jane Smith',
//     email_address: 'jane.smith@example.com',
//     username: 'janesmith',
//     joinDate: '2023-03-22',
//     status: 'active',
//     location: 'New York, NY',
//     bio: 'UX Designer with a love for clean, intuitive interfaces.'
//   },
//   {
//     id: '3',
//     name: 'Mike Johnson',
//     email_address: 'mike.johnson@example.com',
//     username: 'mikej',
//     joinDate: '2023-05-10',
//     status: 'inactive',
//     location: 'Austin, TX',
//     bio: 'Product manager focused on building solutions that matter.'
//   }
// ];

export const checkUserExists = async (portals: User[], userInput: string): Promise<UserCheckResult> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1500));

  const registrants = portals.flatMap((portal: any) =>
    portal.data.map((item: any) => {
      const name =
        item.first_name || item.surname
          ? `${item.first_name || ""} ${item.surname || ""}`.trim()
          : item.full_name || item.title?.rendered || "Unnamed"

      return {
        id: item.id,
        name,
        email: item.email_address,
        phone: item.phone_number,
        form: portal.portal,
        status: item.volunteer?.trim()
          ? "Volunteer"
          : item.vip?.toLowerCase().trim() === "true"
            ? "VIP"
            : "confirmed",
        volunteer: item.volunteer?.trim() ? item.volunteer?.trim() : "No Post",
        joinDate: new Date(item.date).toLocaleDateString(),
      }
    })
  )
  // Check if user exists by ID, username, or email
  const userMapped = registrants.map((value) => value.id);
  console.log("looking for: " + userInput);
  console.log(JSON.stringify(userMapped));
  const user = registrants?.find(u =>
    u.id === Number(userInput) ||
    u.name.toLowerCase() === userInput.toLowerCase() ||
    u.phone.toLowerCase() === userInput.toLowerCase() ||
    u.email.toLowerCase() === userInput.toLowerCase()
  );

  if (user) {
    return {
      status: 'exists',
      user
    };
  } else {
    return {
      status: 'not_found',
      message: 'No user found with the provided identifier.'
    };
  }
};




export const checkUserExists_ = async (
  portals: User[],
  userInput: string,
  retryFn?: any, // function that fetches portals again
  attempt: number = 1              // keep track of retry count
): Promise<UserCheckResult> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1500));

  // If portals is empty and retryFn exists, retry
  if ((!portals || portals.length === 0) && retryFn) {
    if (attempt >= 5) {
      return {
        status: 'not_found',
        message: 'No user found after 5 retries.'
      };
    }

    console.log(`Retrying... attempt ${attempt}`);
    try {
      const newPortals = await retryFn();
      return retryFn(userInput, attempt + 1);
      // return checkUserExists(newPortals, userInput, retryFn, attempt + 1);
    } catch (error) {
      return {
        status: 'error',
        message: 'Retry function failed: ' + error
      };
    }
  }

  // Flatten registrants
  const registrants = portals.flatMap((portal: any) =>
    portal.data.map((item: any) => {
      const name =
        item.first_name || item.surname
          ? `${item.first_name || ""} ${item.surname || ""}`.trim()
          : item.full_name || item.title?.rendered || "Unnamed";

      return {
        id: item.id,
        name,
        email: item.email_address,
        phone: item.phone_number,
        form: portal.portal,
        status: item.volunteer?.trim()
          ? "Volunteer"
          : item.vip?.toLowerCase().trim() === "true"
            ? "VIP"
            : "confirmed",
        volunteer: item.volunteer?.trim() ? item.volunteer?.trim() : "No Post",
        joinDate: new Date(item.date).toLocaleDateString(),
      };
    })
  );

  // Check if user exists by ID, username, phone, or email
  const user = registrants.find(u =>
    // String(u.id) === userInput ||
    u.id === Number(userInput) ||
    u.name.toLowerCase() === userInput.toLowerCase() ||
    u.phone?.toLowerCase() === userInput.toLowerCase() ||
    u.email?.toLowerCase() === userInput.toLowerCase()
  );

  if (user) {
    return { status: 'exists', user };
  } else {
    return {
      status: 'not_found',
      message: 'No user found with the provided identifier.'
    };
  }
};


// export const checkIfTHPUserExists = async (portals: User[], userInput: string): Promise<UserCheckResult> => {
//   // Simulate API delay
//   await new Promise(resolve => setTimeout(resolve, 1500));

//   const registrants = portals.flatMap((portal: any) =>
//     portal.data.map((item: any) => {
//       const name =
//         item.first_name || item.surname
//           ? `${item.first_name || ""} ${item.surname || ""}`.trim()
//           : item.full_name || item.title?.rendered || "Unnamed"

//       return {
//         id: item.id,
//         name,
//         email: item.email_address,
//         phone: item.phone_number,
//         form: portal.portal,
//         status: item.volunteer?.trim()
//           ? "Volunteer"
//           : item.vip?.toLowerCase().trim() === "true"
//             ? "VIP"
//             : "confirmed",
//         volunteer: item.volunteer?.trim() ? item.volunteer?.trim() : "No Post",
//         joinDate: new Date(item.date).toLocaleDateString(),
//       }
//     })
//   )

//   // Simulate table not found error (10% chance)
//   // if (Math.random() < 0.1) {
//   //   return {
//   //     status: 'table_not_found',
//   //     message: 'Database table "users" not found. Please contact system administrator.'
//   //   };
//   // }

//   // // Simulate API error (5% chance)
//   // if (Math.random() < 0.05) {
//   //   return {
//   //     status: 'error',
//   //     message: 'Unable to connect to the database. Please try again later.'
//   //   };
//   // }

//   // Check if user exists by ID, username, or email
//   const userMapped = registrants.map((value) => value.id);
//   console.log(JSON.stringify(userMapped));
//   const user = registrants?.find(u =>
//     u.id === userInput ||
//     u.name.toLowerCase() === userInput.toLowerCase() ||
//     u.phone.toLowerCase() === userInput.toLowerCase() ||
//     u.email.toLowerCase() === userInput.toLowerCase()
//   );

//   if (user) {
//     return {
//       status: 'exists',
//       user
//     };
//   } else {
//     return {
//       status: 'not_found',
//       message: 'No user found with the provided identifier.'
//     };
//   }
// };